// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"rj-z","carouselContainer":"sj-z","carouselContent":"tj-z"};